export const ErrorMessages = {
  '0': {
    TITLE: 'Network Issue',
    DETAILS: `It seems there's a network problem. Please check your connection and try again. If the issue persists, feel free to contact support`,
  },
  '400': {
    TITLE: 'Bad Request',
    DETAILS: `It seems we couldn't process your request. Please double-check the information you entered`,
  },
  '401': {
    TITLE: 'Unauthorized Access',
    DETAILS: `You're not authorized to access this resource. Please log in and try again`,
  },
  '403': {
    TITLE: 'Access Denied',
    DETAILS: `You don't have permission to view this resource. If you believe this is an error, please contact support`,
  },
  '404': {
    TITLE: 'Resource Not Found',
    DETAILS: `The resource you're looking for doesn't exist or might have been moved. Please check the URL or go back to the home page`,
  },
  '422': {
    TITLE: 'Invalid Input',
    DETAILS: `It looks like some of the data you entered isn't valid. Please double-check and try again`,
  },
  '429': {
    TITLE: 'Too Many Requests',
    DETAILS: `Oops! It looks like you've made too many requests in a short time. Please wait a moment and try again`,
  },
  '500': {
    TITLE: 'Server Error',
    DETAILS: `We're experiencing some issues on our end. Please try again later, or contact support if the issue continues`,
  },
  default: {
    TITLE: 'Unexpected Error',
    DETAILS:
      'Whoops, Something went wrong. Please try again or contact us if the error persists',
  },
} as const;
